import App from 'app/app.js';

function AddNewStudentFormSubmissionService(
  $timeout,
  JobStore,
  $window,
  BlockService,
  StatsdService,
  RouterService,
  ShoppingCartStore,
  $uibModal,
  AddVerifiedSubjectService,
  MessageStore,
  RedirectionService,
  SubjectStore
) {
  this.loadJobForAddStudentForm = function (eventData, specOrderFlow, accessedViaSmartLink) {
    return JobStore.loadJob(eventData, specOrderFlow).then(
      function (data) {
        BlockService.unblockUI();

        if (!data || (!!data.data && !data.data.success) || !JobStore.isJobLoaded()) {
          this.relationshipDisclaimer = false;
          this.jobLoadFailed = true;
          if (accessedViaSmartLink) {
            StatsdService.logSmartLinkFailure(RouterService.getSource());
          }
          return;
        }
        const activeJob = JobStore.getJob();
        const subject = ShoppingCartStore.getCurrentSubject();

        if (activeJob.spectrumEnabled && activeJob.sellingMethod === 'SPEC') {
          if (activeJob.orderType === 'PAYMENT' && subject.packages.length === 0) {
            this.loadSpecDialog();
          } else {
            return this.goToNext();
          }
        } else if (!activeJob.spectrumEnabled || JobStore.isSpectrumPayOnly()) {
          this.goToPayOnly();
        } else {
          subject.subjectRelationship = eventData.subjectRelationship;
          return this.goToNext();
        }
      }.bind(this)
    );
  };

  this.loadSpecDialog = function () {
    var modalInstance = $uibModal.open({
      animation: true,
      windowClass: 'modal-sm',
      backdrop: 'static',
      template:
        '<lt-choose-spec-order-drawer ' +
        'on-select-pay-only="modalCtrl.goToPayOnly()" ' +
        'on-select-order="modalCtrl.goToOrder()" ' +
        'cancel-choose-spec="modalCtrl.cancelChooseSpec()" ' +
        'cancellation-button-text="COMMON_TEXT_CANCEL"> ' +
        '</lt-choose-spec-order-drawer>',
      controller: function () {
        this.cancelChooseSpec = function () {
          modalInstance.close();
        };
        this.goToOrder = function () {
          modalInstance.close('goToOrder');
        };
        this.goToPayOnly = function () {
          modalInstance.close('goToPayOnly');
        };
      },
      controllerAs: 'modalCtrl'
    });

    modalInstance.result.then(
      function (action) {
        if (action === 'goToOrder') {
          this.goToOrder();
        } else if (action === 'goToPayOnly') {
          this.goToPayOnly();
        } else {
          // assume cancel
          modalInstance.close();
        }
      }.bind(this)
    );
  };

  this.goToPayOnly = () => {
    $timeout(() => {
      if (JobStore.isEnhancedPayOnly()) {
        this.goToPrepayStudentInfo('ENHANCED_PAYONLY');
      } else {
        this.goToPrepayStudentInfo('PAYONLY');
      }
    }, 10);
  };

  this.goToNext = function () {
    if (JobStore.isPreOrder()) {
      this.goToPrepayStudentInfo();
    } else {
      BlockService.blockUI();
      return AddVerifiedSubjectService.goToProofs();
    }
  };

  this.goToOrder = function () {
    var pdd = ShoppingCartStore.getPictureDayData();
    if (!pdd.accessCode || !JobStore.isJobLoaded()) {
      ShoppingCartStore.removeSubject(ShoppingCartStore.getCurrentSubject()?.id);
      MessageStore.createSystem('HOME_ACCESS_CODE_REQUIRED');
    } else {
      BlockService.blockUI();
      ShoppingCartStore.removeSubject(ShoppingCartStore.getCurrentSubject()?.id);
      pdd.specReorder = true;
      JobStore.loadJob(pdd, true)
        .then(function (data) {
          if (JobStore.isJobLoaded() && !!data && (data === true || (!!data.data && !!data.data.success))) {
            RedirectionService.routeNext();
          }
        })
        ['finally'](function () {
          BlockService.unblockUI();
        });
    }
  };

  this.goToPrepayStudentInfo = (routeTo) => {
    if ($window.optimizeprepic) {
      // TODO: sendPictureDayToApp + below stuff into a reusable method / CommonService
      BlockService.manuallyUnblockUI();

      const currentSubject = ShoppingCartStore.getCurrentSubject();
      currentSubject.subjectFirstName = SubjectStore.generateFirstNamePlaceholder();
      currentSubject.allowPersonalizationNamePrefill = false;
      currentSubject.subjectDetailsDeferred = true;
      const activeJob = JobStore.getJob();
      SubjectStore.addOrUpdateSubjectByJob(activeJob, currentSubject);
      ShoppingCartStore.confirmSubjectAccount();
      RedirectionService.routeNext({ routeTo });
    } else {
      RouterService.goToPrepayStudentInfo(routeTo);
    }
  };
}

App.service('AddNewStudentFormSubmissionService', [
  '$timeout',
  'JobStore',
  '$window',
  'BlockService',
  'StatsdService',
  'RouterService',
  'ShoppingCartStore',
  '$uibModal',
  'AddVerifiedSubjectService',
  'MessageStore',
  'RedirectionService',
  'SubjectStore',
  AddNewStudentFormSubmissionService
]);
